import { BaseInputFilter } from "domain/models/base-input-filter";
import { useParameterByFilter } from "presentation/hooks/use-query-parameter";
import { useParameterStore } from "presentation/stores/use-parameter-store";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";

const DocumentTypeDropdown: React.FC<{
  options: ColumnFilterElementTemplateOptions;
}> = ({ options }) => {
  const { documentType, setDocumentType } = useParameterStore();
  const [documentTypeOptions, setDocumentTypeOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const { data: parameters } = useParameterByFilter({
    limit: 1000,
    sortBy: "value",
    type: "documentToApproval",
  } as BaseInputFilter);

  useEffect(() => {
    if (parameters?.data) {
      setDocumentTypeOptions(
        parameters?.data?.map((item) => ({
          label: item.value,
          value: item.value,
        }))
      );
    }
  }, [parameters]);

  return (
    <Dropdown
      value={options.value}
      options={documentTypeOptions}
      onChange={(e) => options.filterCallback(e.value)}
      placeholder="Selecione o tipo de documento"
      showClear
    />
  );
};
export default DocumentTypeDropdown;
